import React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { buildLineSeries, movingAverage } from './widgetData';

const MovingAverageWidget = ({ widget, rows }) => {
  const { title, xField, yField, window, curve, showLegend } = widget.params || {};
  const { labels, series } = buildLineSeries({ rows, xField, yField });

  if (!labels.length || !series.length) {
    return (
      <WidgetCard
        title={title || 'Moving Average'}
        subtitle={yField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Moving average data is not available yet." />
      </WidgetCard>
    );
  }

  const baseSeries = series[0];
  const averageValues = movingAverage(baseSeries.data, window || 3);

  return (
    <WidgetCard
      title={title || 'Moving Average'}
      subtitle={yField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <LineChart
        height={240}
        xAxis={[{ data: labels, scaleType: 'point' }]}
        series={[
          { data: baseSeries.data, label: baseSeries.label || 'Series', curve: curve || 'monotoneX' },
          { data: averageValues, label: `Avg (${window || 3})`, curve: curve || 'monotoneX' },
        ]}
        legend={{ hidden: !showLegend }}
      />
    </WidgetCard>
  );
};

export default MovingAverageWidget;
